export enum FacilityInputType {
    Date = 1,
    Decimal = 2,
    Select = 3,
    Text = 4,
    Textarea = 5,
    Number = 6
}

export enum FacilityFieldType {
    Date = 1,
    Decimal = 2,
    Integer = 3,
    String = 4,
    Boolean = 5
}

export enum PackageStatus {
    Draft = 1,
    Active = 2,
    Closed = 3
}
export enum AccountType {
    Company = 1,
    Individual = 2
}

// Controlling Person Enums
export enum Title {
    Mr = 1,
    Mrs = 2,
    Miss = 3,
    Other = 4
}

export enum Gender {
    Male = 1,
    Female = 2
}

export enum IdDocumentType {
    NationalId = 1,
    Passport = 2,
    ResidencePermit = 3,
    ResidencePermitIqama = 4
}

export enum MaritalStatus {
    Single = 1,
    Married = 2,
    Divorced = 3,
    Widowed = 4,
    Other = 5
}

export enum EducationLevel {
    Primary = 1,
    Intermediate = 2,
    HighSchool = 3,
    Diploma = 4,
    Bachelor = 5,
    Postgraduate = 6,
    Other = 7
}

export enum EmploymentStatus {
    Employed = 1,
    SelfEmployed = 2,
    Retired = 3,
    Homemaker = 4,
    Student = 5,
    Other = 6
}

export enum EmploymentSector {
    Government = 1,
    Private = 2,
    AffiliateOrSubsidiaryOfListedCompany = 3,
    Military = 4,
    ListedCompany = 5,
    InternationalOrganization = 6
}

export enum DesignationLevel {
    BoardMemberOrSeniorExecutive = 1,
    MiddleManagement = 2,
    Staff = 3,
    NotApplicable = 4
}

export enum PrimaryIncomeSource {
    Investment = 1,
    RentalIncome = 2,
    Salary = 3,
    BusinessIncome = 4,
    PensionIncome = 5,
    Other = 6
}

export enum PrimaryWealthSource {
    Investment = 1,
    Employment = 2,
    Inheritance = 3,
    Business = 4,
    PersonalSavings = 5,
    RealEstate = 6,
    Other = 7
}

export enum OnboardingValidationIssueCategory {
    LegalEntity = 1, 
    ContactAndAddress = 2,
    InvestmentProfile = 3,
    ControllingPersons = 4,
    DirectorsExecutives = 5,
    AuthorizedPersons = 6,
    BankAndCustodian = 7,
    FatcaCrs = 8,
    Documents = 9,
    SignedDocuments = 10


}

/** Borrower / guarantor onboarding application lifecycle (aligned with LMS borrower portal). */
export enum ApplicationStatus {
    Draft = 1,
    Submitted = 2,
    UnderReview = 3,
    Approved = 4,
    Rejected = 5,
    Objected = 6,
    OnHold = 7,
    Withdrawn = 8,
    Signing = 9,
    Signed = 10,
}

export enum KycStatus {
    NotStarted = 1,
    InProgress = 2,
    Submitted = 3,
}

/** Matches backend LegalFormType enum */
export enum LegalFormType {
    LimitedLiabilityCompany = 1,
    PublicJointStockCompany = 2,
    ClosedJointStockCompany = 3,
    SimplifiedJointStockCompany = 4,
    GeneralPartnership = 5,
    LimitedPartnership = 6,
    GovernmentEntity = 7,
    InternationalOrganizationOrInstitution = 8,
    Other = 9,
    NonProfitOrganization = 10,
    Endowment = 11,
    GovernmentFund = 12,
}

/** Matches backend PersonRole enum */
export enum PersonRole {
    AuthorizedPerson = 1,
    Director = 2,
    ControllingPerson = 3
}

/** Matches backend RegistrationConfigurationType enum */
export enum RegistrationConfigurationType {
    LegalEntity = 1,
    Individual = 2,
    KsaIndividual = 3,
    NonKsaIndividual = 4,
}

export enum OnboardingHubEvent {
    ApplicationCreated = 'ApplicationCreated',
    WorkflowForwardedToCompliance = 'WorkflowForwardedToCompliance',
    WorkflowEscalatedToCeo = 'WorkflowEscalatedToCeo',
    WorkflowApproved = 'WorkflowApproved',
    WorkflowRejected = 'WorkflowRejected',
    WorkflowReturnedToInvestor = 'WorkflowReturnedToInvestor',
    WorkflowReturnedToRM = 'WorkflowReturnedToRM',
    WorkflowSentToSigning = 'WorkflowSentToSigning',
    EntityRejected = 'EntityRejected',
    EntityVerified = 'EntityVerified',
    BulkEntitiesRejected = 'BulkEntitiesRejected',
    BulkEntitiesVerified = 'BulkEntitiesVerified',
  }